import { assign } from "xstate"
import * as F from "fp-ts/function"
import { assertEvent } from "../../../../../_common/xstate-helpers"
import { ECommerceEvent } from "../e-commerce-machine"
import { ECommerceContext } from "../e-commerce-machine-context"

type Context = ECommerceContext
type Events = ECommerceEvent

export const paymentActions = {
    setPaymentTrackingId: assign<Context, Events>((ctx, ev) => {
        assertEvent(ev, "START_PAYMENT")
        return {
            paymentTrackingId: ev.trackingId,
        }
    }),
    setPayment: assign<Context, Events>((ctx, ev) => {
        assertEvent(ev, "PAYMENT_STARTED")
        return {
            payment: ev.response.payment,
        }
    }),
    resetPayment: assign<Context, Events>({
        payment: F.constUndefined,
    }),
    setPaymentError: assign<Context, Events>((_, ev) => {
        assertEvent(ev, "PAYMENT_ERROR")
        return {
            paymentError: ev.paymentError,
        }
    }),
    setPaymentResult: assign<Context, Events>((_, ev) => {
        assertEvent(ev, "PAYMENT_CONFIRMED")
        return {
            paymentResult: ev.paymentResult,
        }
    }),
}
